import { useRouter } from 'next/router'
import { useEffect, memo } from 'react'
import { GuestGuard } from '../components/authentication/guest-guard'
import { useAuth } from '../hooks/use-auth'
import { gtm } from '../lib/gtm'
import LoginComponent from './authentication/login.html'

const Login = memo(() => {
    const router = useRouter()
    const { platform } = useAuth()
    const { disableGuard } = router.query

    useEffect(() => {
        gtm.push({ event: 'page_view' })
    }, [])

    return <LoginComponent />
})

Login.getLayout = (page) => <GuestGuard>{page}</GuestGuard>

export default Login
